import React from 'react'

export interface IImageCell {
  content: string
}

export const ImageCell: React.FC<IImageCell> = props => <img className='cbgms-grid--image' src={props.content} />

export default React.memo(ImageCell)
